import React, { Component } from "react";
import config from "../../../shared/services/apiConfig";
import L, { CRS } from "leaflet";
import { MapContainer, MapConsumer, TileLayer, Marker, Popup } from "react-leaflet";

import { withChoosedCar } from "./../../../shared/containers/containerChoosedCar";
import { withMainMap } from "./../../../shared/containers/containerMainMap";
import { withCars } from "./../../../shared/containers/containerCars";
import { withGeozones } from "../../../shared/containers/geozonesContainer";
import { withMapControl } from "../../../shared/containers/containerMapControl";

import MapMarker from "./../../../shared/map/mapMarker";
import { carsStatuses } from "./../cars/static.carsStatuses";
import { states } from "../../../reducers/queriesStates";

import TopRightMapControl from "../../LayerMapCotrol/TopRightMapControl";
import TopLefttMapControl from "../../LayerMapCotrol/TopLeftMapControl";
import StatusMarkerControl from "../../LayerMapCotrol/StatusMarkerControl";
import LayerMapControl from "../../LayerMapCotrol/LayerMapContol";
import BaseLayerMapControl from "../../LayerMapCotrol/BaseLayerMapControl";
import GeozoneEditControl from "../../LayerMapCotrol/GeozoneEditControl";
import GeozoneInfoControl from "../../LayerMapCotrol/GeozoneInfoControl";

import { getDataPoupup } from "../../../services/PoupUpService/poupupService";
import styles from "./carsMap.module.scss";
import { withAppState } from "../../../shared/containers/containerAppState";
import WithToken from "../../../shared/services/tokenService";
import { withAuth } from "../../../shared/containers/containerAuth";
import SearchAddressControl from "../../LayerMapCotrol/SearchAddressControl/SearchAddressControl";
import { searchMarkerIconService } from "../../Geocoders/searchMarkerIconService";
import { withGeocoder } from "../../../shared/containers/containerGeocoder";

class CarsMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statuses: `${carsStatuses.inmotion.id},${carsStatuses.parking.id},${carsStatuses.loss.id}`,
      geozoneControl: this.props.geozonesDataState === states.READY,
      isRendering: true,
      mapBounds: null,
    };
  }

  componentDidMount() {
    const { geozonesDataState, onGetGeozones, listUnits, onSetMapBounds } = this.props;

    if (geozonesDataState !== states.READY) {
      onGetGeozones();
    }

    if (listUnits.length > 0) {
      const latLngs = listUnits
        .filter((item) => {
          return item.lastLocation.lat !== 0;
        })
        .map((item) => L.latLng([item.lastLocation.lat, item.lastLocation.long]));

      if (latLngs.length > 0) {
        onSetMapBounds(new L.latLngBounds(latLngs));
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { dataStateUnits, listUnits, geozonesDataState, geozoneCreateDataState, onSetMapBounds, mapBounds } = this.props;

    if (prevProps.dataStateUnits === states.REQUEST && dataStateUnits === states.READY && listUnits.length > 0) {
      const latLngs = listUnits
        .filter((item) => {
          return item.lastLocation.lat !== 0;
        })
        .map((item) => L.latLng([item.lastLocation.lat, item.lastLocation.long]));

      if (latLngs.length > 0) {
        onSetMapBounds(new L.latLngBounds(latLngs));
      }
    } else if (mapBounds !== null) {
      onSetMapBounds(null);
    }

    if (prevProps.geozonesDataState === states.REQUEST && geozonesDataState === states.READY) {
      this.setState({ geozoneControl: true });
    }

    if (prevProps.geozoneCreateDataState === states.REQUEST && geozoneCreateDataState === states.READY) {
      this.setState({ geozoneControl: true });
    }
  }

  setStatuses(state) {
    this.setState({ statuses: state });
  }

  setZoom(zoom) {
    const { onSetZoom } = this.props;
    onSetZoom(zoom);
  }

  getChildrens() {
    const { statuses } = this.state;
    const { listUnits, mapBaseLayer, onChooseCar, data, isViewCustomMap } = this.props;

    const handlePoupup = (e, unit) => {
      onChooseCar(unit);

      getDataPoupup(e.target, unit.id, { date: unit.lastActive }, [
        {
          title: `<b><a href="/cars/${unit.id}/intimerange" style="font-size: 14px;">Сведения</a></b>`,
          value: "",
        },
        {
          title: "Транспортное средство",
          value: `${unit.unit.title}`,
        },
        { title: "Регистрационный номер", value: `${unit.unit.registerNumber}` },
        /*     { title: "Гаражный номер", value: `${unit.unit.garageNumber ?? ""}` }, */
      ]);
    };

    const customMapTileUrl = config.get("baseURL") + "/CustomMapTiles/{z}/{x}/{y}?Token=" + WithToken.getToken("authTNToken");
    const isAccessCustomMapTile = data.permissions.includes(44001);

    return (
      <div>
        {mapBaseLayer.url.map((_url, index) => {
          return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
        })}

        {isAccessCustomMapTile && isViewCustomMap && mapBaseLayer.crs === CRS.EPSG900913 ? (
          <TileLayer opacity={0.6} url={customMapTileUrl} updateWhenIdle={true} />
        ) : null}

        {listUnits.length > 0
          ? listUnits.map((unit) => {
              if (unit.lastLocation.lat === 0) return null;

              return statuses.split(",").includes(`${unit.status.id}`) ? (
                <MapMarker
                  key={unit.id}
                  position={[unit.lastLocation.lat, unit.lastLocation.long]}
                  status={unit.status.id}
                  number={unit.number}
                  onClick={(e) => handlePoupup(e, unit)}
                />
              ) : null;
            })
          : null}

        <GeozoneEditControl />
      </div>
    );
  }

  render() {
    const { statuses } = this.state;
    const { mapBaseLayer, zoom, mapCenter, mapBounds, isSideBarOpen, searchMapMarkerLocation, dataSearch } = this.props;

    const getIconSearch = (color) => {
      return L.divIcon({
        html: `<div>${searchMarkerIconService.getSeachIcon(color)}</div>`,
        className: "svg-icon",
        iconSize: [60, 60],
        iconAnchor: [30, 60],
      });
    };

    return (
      <div className={styles.carsMap}>
        <MapContainer
          key={`${mapBaseLayer.name} ${zoom} ${mapCenter.lat} ${mapCenter.lng} ${isSideBarOpen}`}
          crs={mapBaseLayer.crs}
          center={mapCenter}
          zoom={zoom}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={false}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}
          className={styles.mapMainWrapper}
        >
          <MapConsumer>
            {(map) => {
              if (mapBounds !== null) {
                map.fitBounds(mapBounds.pad(0.1));
              }

              return null;
            }}
          </MapConsumer>

          {searchMapMarkerLocation !== null && dataSearch !== null ? (
            <Marker
              key={`${searchMapMarkerLocation.lat} ${searchMapMarkerLocation.lon}`}
              position={[searchMapMarkerLocation.lat, searchMapMarkerLocation.lon]}
              icon={getIconSearch("red")}
            >
              <Popup className="mapPopup">{dataSearch}</Popup>
            </Marker>
          ) : null}
          {this.getChildrens()}
        </MapContainer>

        <TopRightMapControl top="10px">
          <StatusMarkerControl setStatus={this.setStatuses.bind(this)} statusesArray={statuses.split(",")} />

          <LayerMapControl routeBlock={false} />
          <BaseLayerMapControl />
        </TopRightMapControl>

        <TopLefttMapControl>
          <SearchAddressControl />
        </TopLefttMapControl>

        <TopLefttMapControl>
          <GeozoneInfoControl />
        </TopLefttMapControl>
      </div>
    );
  }
}

export default withGeocoder(withAuth(withAppState(withMapControl(withGeozones(withCars(withMainMap(withChoosedCar(CarsMap))))))));
